/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import Castle from '../animations/castle';
import Shape from '../animations/shape';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

/**
 *
 */
EDC.Games.BiggestSmallestShapes.Scenes.Main = function () {};
/**
 *
 */
EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype.constructor = EDC.Games.BiggestSmallestShapes.Scenes.Main;
/**
 *
 */
EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype.init = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.BiggestSmallestShapes, 11]);

  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.castle = null;
  this.jester = null;
  this.advice = null;
  this.order = null;
  this.iteration = 0;
  this.targetSize = 0;
  this.shapes = [];

  this.C_SHAPES_COUNT = 3;
  this.C_SHAPES_START_X = 0;
  this.C_SHAPES_AREA_WIDTH = 1200;
  this.C_SHAPES_BOTTOM_Y = 900;
  this.C_SHAPE_SLOT_WIDTH = this.C_SHAPES_AREA_WIDTH / this.C_SHAPES_COUNT;
  this.C_SHAPES_START_X = (this.game.config.width - this.C_SHAPES_AREA_WIDTH) / 2;
};
/**
 *
 */
EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadShapes();

  this.createBasicUI();
};

EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype.createTemplateUI = function () {
  this.add.sprite(this.game.config.width / 2, 1020, 'label-title');
  this.castle = new Castle(this);
  this.castle.create();
  this.castle.place(1100, 230);
  this.castle.startFlying();

  this.jester = this.add.sprite(210, 120, 'jester').setOrigin(0);
  this.advice = this.add.sprite(410, 20, 'advice').setOrigin(0);
  this.order = this.add.sprite(650, 125, this.gameConfig.isBiggest ? 'label-big' : 'label-small');
};

EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype.drop = function (shape) {
  const pos = shape.getPosition();
  const castleBounds = this.castle.getBounds();
  if (castleBounds.contains(pos.x, pos.y)) {
    if (shape.getSizeIndex() === this.targetSize) {
      shape.showMark(false, () => {
        shape.disappear(
          () => {
            this.playCorrect();
            this.iteration = this.iteration + 1;
            if (this.iteration >= this.gameConfig.iterations) {
              this.shapes.forEach((elem) => {
                elem.disable();
              });
              this.showSummary();
            } else {
              this.loadShapes();
            }
          },
        );
      });
    } else {
      this.playWrong();
      shape.showMark(true);
      this.scene.get('thumb').showWrong();
    }
  } else {
    shape.release();
  }
};
/**
 *
 */
EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype.loadShapes = function () {
  for (let i = 0; i < this.shapes.length; i++) {
    this.shapes[i].destroy();
    delete this.shapes[i];
  }
  this.shapes = [];

  const sourceArr = [];
  for (let si = 0; si < 8; si++) {
    sourceArr.push(si);
  }

  for (let i = 0; i < this.C_SHAPES_COUNT; i++) {
    const index = this.getRandomValueFromArray(sourceArr);
    const shape = new Shape(this);
    shape.create(`item-${index}`, index);
    shape.place(
      this.C_SHAPES_START_X + this.C_SHAPE_SLOT_WIDTH * i + this.C_SHAPE_SLOT_WIDTH / 2,
      this.C_SHAPES_BOTTOM_Y - shape.getHeight() / 2,
    );
    shape.hover();
    this.shapes.push(shape);
  }
  this.setTargetSize();
};
/**
 *
 */
EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype.getRandomValueFromArray = function (targetArray) {
  const rndIdx = Math.floor(Math.random() * targetArray.length);
  const res = targetArray.splice(rndIdx, 1);
  return res[0];
};
/**
 *
 */
EDC.Games.BiggestSmallestShapes.Scenes.Main.prototype.setTargetSize = function () {
  this.targetSize = this.shapes[0].getSizeIndex();

  for (let i = 0; i < this.shapes.length; i++) {
    const si = this.shapes[i].getSizeIndex();
    if (this.gameConfig.isBiggest) {
      if (this.targetSize < si) {
        this.targetSize = si;
      }
    } else if (this.targetSize > si) {
      this.targetSize = si;
    }
  }
};

export default EDC.Games.BiggestSmallestShapes.Scenes.Main;
